import 'rxjs/add/operator/race';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/debounceTime';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { entitiesMetaData } from '../metaData';
import { sdkPromise } from '../../../../utils/sdk';
import { handleError, handleSuccess } from '../handleResult';
import { getCurrentEntity, getSelectedEntityId, getSelectedEntityStatus,getSelectedEntity, getAlpsTypeId } from '../selectors';
import { setSelectedSubEntityId,toggleEntity } from '../index';
import { getCurrentTenantId } from "../../userData/selectors";
import { isEmpty } from 'serenova-js-utils/strings';


import { addToPendingSubmit, setTermsForm } from './actions';
import { getPendingSubmit,artifactData,changeVersionIdSubmit, selectTypes } from './selectors';

export const HandlePendingSubmit = ($action, store) =>
  $action
    .ofType('PROMPT_FOR_TERMS')
    .mergeMap(action => {
      const { pendingSubmitValues, name } = action;
      // send values to pendingSubmit, delete current form, open the terms modal
      const newPendingSubmitValues = pendingSubmitValues.set('submitSource', name);
      const arr = [
        addToPendingSubmit(newPendingSubmitValues),
        setSelectedSubEntityId(undefined),

      ];
      if (name !== "createPolicy") {
        arr.push(setTermsForm(true,name))
      }
      return arr;
    });

export const HandleTermsFormSubmit = ($action, store) =>
  $action
    .ofType('TERMS_FORM_SUBMIT')
    .mergeMap(action => {
      const pendingSubmit = getPendingSubmit(store.getState());
      const changeVersionId= changeVersionIdSubmit(store.getState());
      switch (pendingSubmit.get('submitSource')) { 
        case 'createPolicy':
          return [
            {
             type: 'CREATE_ENTITY',
              entityName: 'alps',
              values: pendingSubmit.toJS()
            },
            setTermsForm(false)
          ];
        case 'createVersion':
          return [
            {
              type: 'CREATE_ENTITY',
              entityName: 'alps',
              selectedEntity: pendingSubmit.get('id'),
              subEntityName: 'version',
              values: pendingSubmit.toJS()
            },
            setTermsForm(false)
          ];
        case 'changeVersion':
          return [
            {
              type:'CHANGE_VERSION',
              entityName: 'alps',
              entityId: pendingSubmit.get('id'),
              values: changeVersionId!==undefined ? changeVersionId.get('versionId'):""
            },
            setTermsForm(false)
          ];
        case 'enablePolicy':
          return [
            {
              type: 'ENABLE_ALPS_POLICY',
              entityName: 'alps',
           },
           setTermsForm(false)
          ];
          case 'disablePolicy':
            return [
              {
                type: 'DISABLE_ALPS_POLICY',
                entityName: 'alps',
             },
             setTermsForm(false)
            ]
        default:
          return [setTermsForm(false)];
      }
    });
   
export const EnablePolicy = ($action,store) =>
  $action
    .ofType('ENABLE_ALPS_POLICY','DISABLE_ALPS_POLICY')
    .filter(action => action.entityName === 'alps')
    .map(action => { 
      const data=store.getState().get('Entities').get('alps');
      action.bool = data.get('pendingSubmit').get('submitSource') == "enablePolicy" ? true : false;
      const artifactVersions=data.get('artifactVersions');
      const activeVersion=artifactVersions.find(version=>version.active==true);
      
      action.sdkCall = {
        module: 'entities',
        data: {
          "enable": action.bool,
          "activeVersion":activeVersion.versionId,
          "acknowledgment": {
            "active-storage-usage ": true,
            "archival-retrieval ": true,
            "enabled-policy-deleted-artifacts": action.bool,
            "enabled-policy-archive-storage-usage ": action.bool,
            "disabled-policy-archive-storage-usage ": !action.bool,
            "disabled-policy-active-storage-retention ": !action.bool,
          }
        },
        command: 'toggleAlps',
        topic: 'cxengage/entities/toggle-alp-response',
        crudAction: 'update',
        apiVersion: entitiesMetaData['alps'].sdkCall.apiVersion
      };
      return { ...action };
    }).concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        .map(response => {
        const type1= action.bool==true?"enabled":"disabled"
          return handleSuccess(response, action, `Artifact Lifecycle Policy ${type1} successfully!`) 
        }
        )
        .catch(error => handleError(error, action))
    );

    const getRefreshedData = () => {
      let fetchDataObj = {
        "apiVersion": entitiesMetaData['alps'].sdkCall.apiVersion,
        "command": "getAlps",
        "crudAction": "read",
        "module": "entities",
        "path": entitiesMetaData['alps'].sdkCall.path,
        "topic": "cxengage/entities/get-alps-response",
        "entityName": "alps"
      };   
      return [{ ...fetchDataObj, type: 'FETCH_DATA' }]
    }

    export const changeVersion = ($action,store) =>
  $action
    .ofType('CHANGE_VERSION')
    .filter(action => action.entityName === 'alps')
    .map(action => { 
     const {values} = action;
      let type=true;
      action.sdkCall = {
        module: 'entities',
        data: {
          "active": type,
          "activeVersion":action.values,
          "acknowledgment": {
            "active-storage-usage ": type,
            "archival-retrieval ": type,
            "enabled-policy-deleted-artifacts": type,
            "enabled-policy-archive-storage-usage ": type,
            "disabled-policy-archive-storage-usage ": !type,
            "disabled-policy-active-storage-retention ": !type,
          }
        },
        command: 'activateAlpsVersion',
        topic: 'cxengage/entities/activate-alps-version-response',
        crudAction: 'update',
        apiVersion: entitiesMetaData['alps'].sdkCall.apiVersion
      };
      return { ...action };
    }).concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        // .map(response => {
        //   return handleSuccess(response, action, `Artifact Lifecycle Policy active version changed successfully!`) 
        // }
        .mergeMap(response => {
          const actionList = [
            handleSuccess(response, action, `Artifact Lifecycle Policy active version changed successfully!`),   
             ...getRefreshedData()
          ];
          return actionList;
        }
        )
        .catch(error => handleError(error, action))
    );

export const CreateEntity = ($action, store) =>
  $action
    .ofType('CREATE_ENTITY')
    .filter(action => action.entityName === 'alps')
    .map(action => {
      let { values, entityName } = action;
      const artifactTypes = selectTypes(store.getState());
     // const selectedEntityId=store.getState().get('Entities').get('alps').get('selectedEntityId');
     const selectedEntityId=getSelectedEntityId(store.getState());
      if(selectedEntityId!=='create'){
       // const data=store.getState().get('Entities').get('alps').get('data');
        const data=artifactData(store.getState());
        if(data!==undefined){
        const obj=data.find(versions => selectedEntityId==versions.get('versionId')).toJSON();
        obj.artifactSubType=obj.artifactSubType==""?null:obj.artifactSubType;
        delete obj.activeAction;
        delete obj.activeDuration
        delete obj.archiveAction
        delete obj.archiveDuration
        delete obj.versionName

        values={...values,...obj};
        }
      }else {
        if(isEmpty(values.artifactSubType)){
            values.artifactSubType="null";
        }
      }
      const matchedArtifactType = artifactTypes
        ? artifactTypes.find(artifactType=>( artifactType.artifactTypeName === values.artifactTypeName) || (artifactType.artifactTypeName === values.artifactType) )
        : '';
        
      // if (values.artifactSubType == 'null') {
      //   delete values.artifactSubType
      // }
      
      action.sdkCall = {
        module: 'entities',
        data: { ...values, ...matchedArtifactType },
        command: 'createAlp',
        topic: 'cxengage/entities/create-alp-response',
        crudAction: 'create',
        apiVersion: entitiesMetaData[entityName].sdkCall.apiVersion
      };
      return { ...action };
    })
    .concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        .map(response => handleSuccess(response, action, 'Artifact Lifecycle Policy was created successfully!'))
        .catch(error => handleError(error, action))
    );

export const CreateSubEntity = ($action, store) =>
  $action
    .ofType('CREATE_SUB_ENTITY')
    .map((action) => ({
      ...action,
      entityName: getCurrentEntity(store.getState()),
      entityId: getSelectedEntityId(store.getState())
    }))
    .filter(({ entityName }) => entityName === 'alps')
    .map((a) => {
      // todo: only return object (dont need the brackets)
      a.sdkCall = {
        module: 'entities',
        data: a.values,
        command: 'createAlpVersion',
        topic: 'cxengage/entities/create-alp-version-response',
        crudAction: 'create',
        apiVersion: entitiesMetaData[a.entityName].sdkCall.apiVersion
      };
      return { ...a };
    })
    .concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        .map(response => handleSuccess(response, action, 'Artifact Lifecycle Policy was created successfully!'))
        .catch(error => handleError(error, action))
    );

export const fetchLoadHistory = ($action, store) =>
  $action
    .ofType('LOAD_HISTORY')
    .concatMap(action =>
      fromPromise(sdkPromise({
        crudAction: 'read',
        path: ['artifact-policies', getAlpsTypeId(store.getState()), 'change-history'],
        command: 'getLoadHistory',
        module: 'entities',
        topic: 'cxengage/entities/load-history',
        tenantId: getCurrentTenantId(store.getState())
      }))
        .map(response => {
          return ({
            type: 'FETCH_ARTIFACT_LOAD_HISTORY_FULFILLED',
            artifactHistory: response.result
          })
        })
        .catch(error => handleError(error, action))
    );

export const fetchVersion = ($action, store) =>
  $action
    .ofType('FETCH_DATA_ITEM', 'SET_CURRENT_ENTITY')
    .filter(a => a.entityName === 'alps' && getAlpsTypeId(store.getState()))
    .concatMap(action =>
      fromPromise(sdkPromise({
        crudAction: 'read',
        path: ['artifact-policies', getAlpsTypeId(store.getState())],
        command: 'getVersion',
        module: 'entities',
        topic: 'cxengage/entities/fetch-version',
        tenantId: getCurrentTenantId(store.getState())
      }))
        .map(response => {
          return ({
            type: 'FETCH_ARTIFACT_VERSIONS_FULFILLED',
            artifactVersions: response.result
          })
        })
        .catch(error => handleError(error, action))
    );

export const FetchArtifactTypesAfterALPs = ($action, store) =>
  $action
    .ofType('FETCH_DATA_FULFILLED')
    .filter(a => a.entityName === 'alps' || a.entityName === 'amr')
    .map((action) => ({
      ...action,
      selectedEntityId: getSelectedEntityId(store.getState()),
      sdkCall: {
        apiVersion: 'v1',
        command: 'getAlpTypes',
        crudAction: 'read',
        module: "entities",
        path: ['artifact-policies'],
        topic: 'cxengage/entities/get-alp-types-response',
      }
    }))
    .concatMap(action => {
      return fromPromise(sdkPromise(action.sdkCall))
        .map(response => ({
          type: 'FETCH_ARTIFACT_TYPES_FULFILLED',
          artifactTypes: response.result,
          entityType: action.entityName
        }))
        .catch(error => handleError(error, action))
    }
    );
export const FetchRequestTypesAfterALPs = ($action, store) =>
  $action
    .ofType('FETCH_DATA_FULFILLED')
    .filter(a => a.entityName === 'amr')
    .map((action) => ({
      ...action,
      selectedEntityId: getSelectedEntityId(store.getState()),
      sdkCall: {
        apiVersion: 'v1',
        command: 'getAmrRequest',
        crudAction: 'read',
        module: "entities",
        path: ['artifact-policies'],
        topic: 'cxengage/entities/get-amr-request-types',
      }
    }))
    .concatMap(action => {
      return fromPromise(sdkPromise(action.sdkCall))
        .map(response => ({
          type: 'FETCH_AMR_REQUEST_TYPES_FULFILLED',
          requestType: response.result,
        }))
        .catch(error => handleError(error, action))
    }
    );

export const AfterEntityCreate = ($action, store) =>
  $action
    .ofType('CREATE_ENTITY_FULFILLED', 'CREATE_SUB_ENTITY_FULFILLED')
    .filter(({ entityName }) => entityName === 'alps')
    .map((a) => {
      return {
        type: 'SET_SELECTED_ENTITY_ID',
        entityId: a.response.result[0].versionId
      };
    });

export const UpdateEntity = ($action, store) =>
  $action
    .ofType('UPDATE_ENTITY')
    .filter(({ entityName }) => entityName === 'alps')
    .map((action) => {
      return {
        ...action,
        sdkCall: {
          apiVersion: 'v1',
          command: 'updateAlp',
          crudAction: 'update',
          data: {
            alpId: action.values && action.values.activeVersion,
            updateBody: action.values
          },
          module: "entities",
          path: ['artifact-policies'],
          topic: 'cxengage/entities/update-alp-response',
        }
      };
    })
    .concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        .map(response => handleSuccess(response, action, 'Artifact Lifecycle Policy was updated successfully!'))
        .catch(error => handleError(error, action))
    );